module.exports = __webpack_public_path__ + "img/Iconos_15.894f4b2a.png";